/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

// Check if the AP has been selected

// Components
import Table from "./Childs/Table";
import AdvanceSelector from "../../Common/Helpers/AdvanceSelector/AdvanceSelector";

// CommonComponents
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";

// Image for adding a layer class
import add_choice_class from "../../../icons/add_choice_class.svg";
import FormCard from "../../Common/Childs/Structure/FormCard";
import Delete from "./Delete";
import Form from "./Childs/Form";
import { useGlobal } from "../../../context/GlobalContextProvider";

// Initial state for form data
const initialState = {
  id: 0,
  layer_class_name: "",
  layer_choice_id: 0,
};

const Index = () => {
  const { artPack, setSpinner } =
    useGlobal();

  // State for holding data
  const [data, setData] = useState([]);

  // State for holding parent values (patterns)
  const [patternList, setPatternList] = useState([]);
  const [patternId, setPatternId] = useState(0);

  // State for holding layer values
  const [layerList, setLayerList] = useState([]);
  const [layerId, setLayerId] = useState(0);

  // State for holding layer choice values
  const [layerChoiceList, setLayerChoiceList] = useState([]);
  const [layerChoiceId, setLayerChoiceId] = useState(0);

  // State for form visibility and data
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState(initialState);

  // Effect to fetch all patterns when the art pack changes
  useEffect(() => {
    const getDataPattern = async () => {
      const res = await fetch(`/api/artpack/${artPack?.art_pack_id}/pattern`);

      if (res.status === 200) {
        const json = await res.json();

        const data = json.map((el) => {
          return {
            id: el.pattern_id,
            name: el.pattern_name,
          };
        });

        setPatternList(data);
        setPatternId(data ? data[0]?.id : 0); // Set the default pattern ID
      }
    };
    if (artPack?.art_pack_id) getDataPattern(); // Fetch patterns if art pack is available
  }, [artPack]);

  // Effect to fetch layers filtered by selected pattern ID
  useEffect(() => {
    setLayerList([]); // Reset layer list when pattern ID changes
    const getLayerByPattern = async () => {
      const res = await fetch(`/api/pattern/${patternId}/layer`);

      if (res.status === 200) {
        const json = await res.json();
        const data = json.map((el) => {
          return {
            id: el.layer_id,
            name: el.layer_name,
          };
        });
        setLayerList(data);
        setLayerId(data ? data[0]?.id : 0); // Set the default layer ID
      }
    };
    if (patternId) getLayerByPattern(); // Fetch layers if a pattern ID is selected
  }, [patternId]);

  // Effect to fetch layer choices filtered by selected layer ID
  useEffect(() => {
    setLayerChoiceList([]); // Reset layer choice list when layer ID changes
    const getLayerChoiceByLayer = async () => {
      const res = await fetch(`/api/layer/${layerId}/layerchoice`);

      if (res.status === 200) {
        const json = await res.json();
        const data = json.map((el) => {
          return {
            id: el.layer_choice_id,
            name: el.layer_url,
          };
        });
        setLayerChoiceList(data);
        setLayerChoiceId(data ? data[0]?.id : 0); // Set the default layer choice ID
      }
    };
    if (layerId) getLayerChoiceByLayer(); // Fetch layer choices if a layer ID is selected
  }, [layerId]);

  // Function to load table data for layer choice classes
  const loadTableData = async () => {
    setSpinner(true); // Show spinner while loading data
    const res = await fetch(
      `/api/layerchoice/${layerChoiceId}/layerchoiceclass`
    );
    if (res.status === 200) {
      const json = await res.json();
      const data = json.map((el) => {
        return {
          layer_class_id: el.layer_class_id,
          layer_class_name: el.layer_class_name,
          layer_choice_id: el.layer_choice_id,
        };
      });
      setData(data); // Set the table data
    }
    setSpinner(false); // Hide spinner after loading data
  };

  // Effect to fetch layer choice classes when layer choice ID changes
  useEffect(() => {
    if (layerChoiceId) loadTableData(); // Load table data if a layer choice ID is selected
  }, [layerChoiceId]);

  // Function to create a new layer choice class
  const createItem = async (data) => {
    await fetch(`/api/layerchoice/${layerChoiceId}/layerchoiceclass`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then((res) => {
      loadTableData(); // Reload table data after creating
      onDiscard(); // Reset form
    });
  };

  // Function to update an existing layer choice class
  const updateItem = async (data) => {
    const { id } = formData; // Get ID from form data
    const url = `/api/layerchoice/${layerChoiceId}/layerchoiceclass/${id}`;
    await fetch(url, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then((res) => {
      loadTableData(); // Reload table data after updating
      onDiscard(); // Reset form
    });
  };

  // Function to delete a layer choice class
  const deleteItem = async () => {
    const { id } = formData; // Get ID from form data
    const url = `/api/layerchoice/${layerChoiceId}/layerchoiceclass/${id}`;
    await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then((res) => {
      loadTableData(); // Reload table data after deletion
      onDiscard(); // Reset form
    });
  };

  // Function to handle the edit action
  const onEdit = (data) => {
    setShowForm(true); // Show the form for editing
    setFormData(data); // Set the form data to the selected item
  };

  // Function to handle the delete action
  const onDelete = (data) => {
    setShowForm(false); // Hide the form
    setFormData(data); // Set the form data to the selected item for deletion
  };

  // Function to reset the form
  const onDiscard = () => {
    setShowForm(false); // Hide the form
    setFormData(initialState); // Reset the form data
  };

  // Conditional rendering for the form
  if (showForm) {
    return (
      <>
        <Title title="Pattern" />
        <Description />
        <FormCard>
          <Form
            handleSubmit={
              formData?.layer_class_name ? updateItem : createItem
            }
            formData={formData} // Current form data
            formDataPattern={patternList} // Available patterns for selection
            onDiscard={onDiscard} // Function to reset the form
          />
        </FormCard>
      </>
    );
  }

  // Conditional rendering for the delete confirmation
  if (!showForm && formData?.id && formData?.delete) {
    return (
      <Delete
        onDiscard={onDiscard} // Function to reset the form
        handleSubmit={deleteItem} // Function to handle deletion
        formData={formData} // Data for the item to delete
      />
    );
  }

  // Main component rendering
  return (
    <>
      <Title title="Choice Class" />

      <Description text={"Create a list of approved names for NFTs minted using this Art Pack."} />

      <div className="row m-button-add">
        <div className="mb-4">
          {/* Pattern Selector */}
          <AdvanceSelector
            data={patternList} // List of patterns to choose from
            module="pattern"
            name="pattern_id"
            id="pattern_id"
            label="Pattern"
            enable={true}
            handleChange={(e) => {
              setPatternId(e.target.value); // Update selected pattern ID
            }}
            value={patternId} // Currently selected pattern ID
          />

          <div className="mb-3"></div>

          {/* Layer Selector */}
          <AdvanceSelector
            data={layerList} // List of layers to choose from
            module="layer"
            name="layer_id"
            id="layer_id"
            label="Layer"
            enable={true}
            handleChange={(e) => {
              setLayerId(e.target.value); // Update selected layer ID
            }}
            value={layerId} // Currently selected layer ID
          />

          <div className="mb-3"></div>

          {/* Layer Choice Selector */}
          <AdvanceSelector
            data={layerChoiceList} // List of layer choices to choose from
            module="layer_choice"
            name="layer_choice_id"
            id="layer_choice_id"
            label="Layer Choice"
            enable={true}
            handleChange={(e) => {
              setLayerChoiceId(e.target.value); // Update selected layer choice ID
            }}
            value={layerChoiceId} // Currently selected layer choice ID
          />
        </div>

        <button
          type="button"
          className="btn btn-primary col-md-3 btn-add-class m-0"
          onClick={() => setShowForm(true)} // Show form for adding a new layer choice class
        >
          <img src={add_choice_class} alt="Add" />
          Add Layer Class
        </button>
      </div>

      {/* Render the data table */}
      <Table
        data={data} // Data for the table
        onEdit={onEdit} // Function to handle edit action
        onDelete={onDelete} // Function to handle delete action
        isAllowedToEditOrDelete={artPack?.approved} // Permission check for edit/delete
      />
    </>
  );
};

export default Index;
